export default __webpack_public_path__ + "static/media/Toshkent.fa25eecd.jpeg";